const React = require('react')
const PropTypes = require('prop-types')
const SocialIcon = require('module/icons/social_icon')

function SocialLink(props) {
    const title = `Visit me on ${props.social_link_data.label}`

    return (
        <li>
            <a
                className="social-link"
                title={title}
                href={props.user_data.site_url}
                target="_blank"
                rel="me nofollow noopener noreferrer"
                >
                <SocialIcon glyph={props.social_link_data.id} />
            </a>
        </li>
    )
}

SocialLink.propTypes = {
    user_data: PropTypes.shape({
        site_url: PropTypes.string.isRequired,
    }).isRequired,
    social_link_data: PropTypes.shape({
        label: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
    }).isRequired,
}

module.exports = SocialLink
